import React, { useState } from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import {
  AdminPayrollRatesPanel,
  AdminPayrollSuccessScreen,
} from "./panels/AdminPayrollRatesPanel";

export function AdminPayrollRatesScreen({ onBack }) {
  const [savedState, setSavedState] = useState(null);

  if (savedState) {
    return (
      <AdminPayrollSuccessScreen
        {...savedState}
        onBackToPayroll={() => setSavedState(null)}
      />
    );
  }

  return (
    <CrewPilotModuleShell
      title="Payroll Rates"
      subtitle="Trade, classification, and payroll type rate matrix"
      sectionLabel="Payroll"
      onBack={onBack}
      layout={PAGE_LAYOUT.COMMAND}
    >
      <AdminPayrollRatesPanel onSaved={setSavedState} />
    </CrewPilotModuleShell>
  );
}
